export default "__VITE_ASSET__31e9e6ce__"